import { useNavigate } from "react-router-dom";
import { MobileFrame } from "@/components/MobileFrame";
import { Icon } from "@/components/primitives";
import { useAuth } from "@/hooks/useAuth";
import { useNotificationPrefs, type NotificationPrefs } from "@/lib/notificationPrefs";
import type { NotificationKind } from "@/hooks/useNotifications";

const ROWS: { key: NotificationKind; title: string; sub: string }[] = [
  { key: "grail",    title: "Grail matches",   sub: "When someone posts a piece on your want list" },
  { key: "message",  title: "Direct messages", sub: "New DMs from other collectors" },
  { key: "comment",  title: "Comments",        sub: "Replies on your posted scans" },
  { key: "reaction", title: "Reactions",       sub: "Loves and grails on your pieces" },
  { key: "verification", title: "Verification updates", sub: "Background scan + bulk job activity" },
];

/** Notification preferences — toggle which kinds of activity show up in
 *  the Notifications feed. Stored locally per user. */
export default function SettingsNotifications() {
  const nav = useNavigate();
  const { user } = useAuth();
  const { prefs, set } = useNotificationPrefs(user?.id);
  const update = (k: keyof NotificationPrefs, v: boolean) => set({ ...prefs, [k]: v });

  return (
    <MobileFrame>
      <div style={{ padding: "20px 20px 12px", display: "flex", alignItems: "center", gap: 10 }}>
        <button
          onClick={() => nav(-1)}
          aria-label="Back"
          style={{
            background: "none", border: "1px solid hsl(var(--ink))",
            padding: 6, cursor: "pointer", color: "hsl(var(--ink))",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 32, height: 32,
          }}
        >
          {Icon.chev(14)}
        </button>
        <h1 style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 800, fontSize: 22, margin: 0 }}>
          Notification preferences
        </h1>
      </div>
      <p style={{ padding: "0 20px", fontFamily: "'Fraunces', 'Cormorant Garamond', serif", fontSize: 14, color: "hsl(var(--ink-2))", marginTop: 4 }}>
        Choose which activity shows up in your notifications feed.
      </p>
      <div style={{ borderTop: "1px solid hsl(var(--ink))", marginTop: 12 }}>
        {ROWS.map((r) => {
          const on = prefs[r.key];
          return (
            <label
              key={r.key}
              style={{
                display: "flex", alignItems: "center", gap: 12,
                padding: "14px 20px", borderBottom: "1px solid hsl(var(--ink) / 0.12)",
                cursor: "pointer",
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 700, fontSize: 15, color: "hsl(var(--ink))" }}>
                  {r.title}
                </div>
                <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: "hsl(var(--ink-2))", marginTop: 2 }}>
                  {r.sub}
                </div>
              </div>
              <input
                type="checkbox"
                checked={on}
                onChange={(e) => update(r.key, e.target.checked)}
                style={{ width: 22, height: 22, accentColor: "hsl(var(--rust))", cursor: "pointer" }}
                aria-label={`Toggle ${r.title}`}
              />
            </label>
          );
        })}
      </div>
    </MobileFrame>
  );
}